export class JoinOrganization {
  public static readonly type = "[Organizations] Join Organization";
  public constructor(public organizationId: string, public inviteKey: string) {}
}
